import { ChangeEvent, useContext, useState } from "react";
import Search from "../../components/search/Search";
import { useQuery } from "react-query";
import CardList from "./components/CardList";
import { fetchPlantList } from "../../api/plantManagement";
import Loader from "../../components/loader/Loader";
import AppContext from "../../context/context";

const PlantManagement = () => {
  const [searchResult, setSearchResult] = useState("");

  const { isLoading, data }: any = useQuery({
    queryKey: "plantList",
    queryFn: () => fetchPlantList(),
  });

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchResult(e.target.value);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="my-2 flex justify-center">
        <Search
          value={searchResult}
          handleSearch={handleSearch}
          placeholder="Search plant..."
        />
      </div>
      <div className="flex gap-5 justify-center sm:justify-evenly sm:gap-5 flex-wrap mt-10">
        <CardList data={data} searchResult={searchResult} />
      </div>
    </>
  );
};

export default PlantManagement;
